import CustomCard from '../../../../components/CustomCard';
import {CommentsTitle} from '../../../../components/buttons/IconButtons';
import {useSelector} from "react-redux";
import React from "react";
import NotInformation from "../../../../components/NotInformation";
/**
 * @Author: Susana García Rodríguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */
const ReservationApprovalComments = ({ t }) => {
    const { getEventApprovalComments } = useSelector((state) => state?.EmployeeEventsSlice);
    return (
        <>
            <CustomCard classCard='card-border-8px' classContent='p-0 overflow-hidden'>
                <div className='d-flex align-items-center p-3'>
                    <div><CommentsTitle /></div>
                    <div className='ml-2'>
                        <p className={'font-color-general-950 ibl-font-w-600 fs-14px'}>{t('approval_comments')}</p>
                    </div>
                </div>
                <div className='border-bottom-shades-300' />
                {getEventApprovalComments?.length === 0 ?
                    <div className='h-170px'>
                        <NotInformation text={t('no_comments_found')} card={true} className={"h-100"}
                                        classNameImage={"h-100px py-1"}/>
                    </div>
                    :
                    <div className='h-170px overflow-y-auto p-3'>
                        <ul>
                            {getEventApprovalComments.map((comment, index) => (
                                <li key={index} className='font-color-general-950 fs-14px ml-2 mb-0'>
                                    {comment}
                                </li>
                            ))}
                        </ul>
                    </div>
                }
            </CustomCard>
        </>
    );
};

export default ReservationApprovalComments;
